import dataApplicationsContext from "../../context/dataApplicationsContext"
import { useContext, useEffect, useState, useRef } from 'react';
import UserOnglet from "../user/UserOnglet";
import CardHelpLink from "./CardHelpLink";
import { useNavigate } from "react-router-dom";
import MobilSearch from "./MobilSearch";
import SearchInput from "./SearchInput";

const HelpIndex = () => {
  const { auth, setOngletPaiementActif, windowWidth, homeOngletActif, setHomeOngletActif } = useContext(dataApplicationsContext);

  const navigate = useNavigate();

  // const [ongletActif, setOngletActif] = useState('');

  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const handleNavigate = (link) => {
    window.scrollTo(0, 0);
    navigate(link)
  }

  return (
    <>
      <div className="user-setting-container help home">
        <h1 className="user-title fz-24">Bonjour{auth?.user?.first_name ? ` ${auth?.user?.first_name}` : ''}, comment pouvons-nous vous aider ?</h1>
        <SearchInput formClass={`chart-search-container min-h-40`} wrapperClass="pos-rel z-10 fl-gr-1 max-w-450" readOnly={windowWidth < 744}/>
        <div className="mb-56">
          <div className="help-content-container">
            <div className="d-flex sp-bw">
              <UserOnglet
                onglets={[{label: 'Athlète', id: 1}, {label: 'Organisateur', id: 2}]} classContainer='mb-0'
                ongletActif={homeOngletActif} setOngletActif={setHomeOngletActif}
              />
              <button className="contact-btn see-all ml-40" onClick={() => handleNavigate('/topics')}>Voir tous les sujets</button>
            </div>
            {homeOngletActif.id === 1 && 
              <>
                <p className="fw-500 fz-13 op-7 mt-16">Tout ce que vous devez savoir sur la gestion de votre profil, de vos inscriptions, et bien d'autres.</p>
                <div className="help-card-grid-container index">
                  <CardHelpLink 
                    slug='Lien rapide' title='MON COMPTE' link='topics/acces-rapide/compte' isCardlink
                    description="Vous souhaitez mettre à jour votre profil ou modifier votre compte ? Aucun problème !"
                    containerClass="help-card-container" slugClass="help-slug" titleClass="help-title" descriptionClass="help-description-home"
                  />
                  <CardHelpLink 
                    slug='Lien rapide' title='INSCRIPTION' link='topics/acces-rapide/inscription' isCardlink
                    description="Tous les tips pour gérer et modifier vos inscriptions à vos compétitions."
                    containerClass="help-card-container" slugClass="help-slug" titleClass="help-title" descriptionClass="help-description-home"
                  />
                </div>
              </>
            }
            {homeOngletActif.id === 2 && 
              <>
                <p className="fw-500 fz-13 op-7 mt-16">Découvrez comment créer et gérer votre compétition. Tout ce qu'il faut savoir.</p>
                <div className="help-card-grid-container index">
                  <CardHelpLink 
                    slug='Lien rapide' title='OPTIMISER VOTRE ANNONCE' link='topics/acces-rapide/optimize-annonce' isCardlink
                    description="Mettez en avant les détails clés de votre compétition pour attirer plus d'athlètes."
                    containerClass="help-card-container" slugClass="help-slug" titleClass="help-title" descriptionClass="help-description-home"
                  />
                  <CardHelpLink 
                    slug='Lien rapide' title='RECEVOIR VOS PAIEMENTS' link='topics/acces-rapide/receive-payment' isCardlink
                    description="Voici des informations importantes sur les versements."
                    containerClass="help-card-container" slugClass="help-slug" titleClass="help-title" descriptionClass="help-description-home"
                  />
                </div>
              </>
            }
          </div> 
          {windowWidth < 680 &&
            <div className="d-flex sp-bw cursor-pointer mt-24" onClick={() => handleNavigate('/topics')}>
              <p className='fz-16 fw-500 mb-0'>Parcourir tous les sujets</p>
              <i className={`bi bi-chevron-right fz-20`}></i>
            </div>
          } 
        </div>
      </div>
    </>
  )
}

export default HelpIndex